import { useCallback, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Swal from 'sweetalert2'
import useCertificationsApi from '../../list/hooks/useCertificationsApi'

export default function useCertificationEditPage() {
	const { t } = useTranslation()
	const { id } = useParams()
	const navigate = useNavigate()
	const { getCertificationById, updateCertification } = useCertificationsApi()
	const [certification, setCertification] = useState(null)
	const [loading, setLoading] = useState(true)
	const [submitting, setSubmitting] = useState(false)

	const handleCancel = useCallback(() => {
		navigate('/centrumSzkolen/certyfikaty')
	}, [navigate])

	const loadCertification = useCallback(async () => {
		setLoading(true)
		const { data, error } = await getCertificationById(id)

		if (error) {
			await Swal.fire(
				t('trainingCertifications.messages.errorTitle'),
				error || t('trainingCertifications.edit.messages.loadFailed'),
				'error'
			)
			navigate('/centrumSzkolen/certyfikaty')
			return
		}

		setCertification(data)
		setLoading(false)
	}, [getCertificationById, id, navigate, t])

	useEffect(() => {
		if (id) loadCertification()
	}, [id, loadCertification])

	const handleSubmit = useCallback(async payload => {
		if (submitting) return

		setSubmitting(true)
		const result = await updateCertification(id, payload)

		if (!result.success) {
			await Swal.fire(
				t('trainingCertifications.messages.errorTitle'),
				result.error || t('trainingCertifications.edit.messages.updateFailed'),
				'error'
			)
			setSubmitting(false)
			return
		}

		await Swal.fire(
			t('trainingCertifications.edit.messages.updatedTitle'),
			t('trainingCertifications.edit.messages.updatedSuccess'),
			'success'
		)

		setSubmitting(false)
		navigate('/centrumSzkolen/certyfikaty')
	}, [id, navigate, submitting, t, updateCertification])

	return {
		certification,
		handleCancel,
		handleSubmit,
		loading,
		submitting,
	}
}
